// extracted by mini-css-extract-plugin
module.exports = {"revOrderReview":"style__revOrderReview__gGlDT","accordianComplete":"style__accordianComplete__TIS2M"};